export default __webpack_public_path__ + "static/media/translate.6f1b47e2.svg";